/* eslint-disable @typescript-eslint/no-unused-vars */

import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import styled from 'styled-components';

import { ExamViewModel } from '../../exam.vm';
import Correct from '../icons/Correct-result.svg';
import Wrong from '../icons/Wrong-result.svg';
import MultiStep from '../multi-step';

const ResultContainer = styled.div`
  position: relative;
  height: auto;
  min-height: 100vh;
  padding: 48px 88px;
  background: #333;
  width: 100%;

  @media (max-width: 860px) {
    padding: 20px 28px;
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  color: #ffffff;
`;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  gap: 32px;
`;

const ContainerQuestions = styled.div`
  width: 100%;
  padding-bottom: 92px;
  display: flex;
  flex-direction: column;
`;

const ContainerResult = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 64px;

  & > span {
    display: flex;
    flex-direction: row;
  }

  & p {
    color: var(--color-primary-gray-05, #ddd);
    leading-trim: both;
    text-edge: cap;
    font-family: Aprova Nova;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 16px */
  }

  @media (max-width: 480px) {
    gap: 30px;
  }
`;

const ResultTitle = styled.h2`
  color: var(--color-primary-gray-07, #fff);
  font-family: Aprova Nova;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
  letter-spacing: -1px;
`;

const ResultText = styled.div`
  font-family: 'Aprova Nova';
  font-size: 56px;
  font-weight: 800;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: normal;
  justify-content: flex-end;

  & p {
    color: var(--color-primary-gray-05, #ddd);
    font-family: Aprova Nova;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
`;

const ResultTextIcon = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;

  & > img {
    margin-right: 8px;
    align-self: center;
    max-width: 24px;
  }
`;

const ResultTextContainer = styled.div`
  display: flex;
  flex: row;
`;

const TotalResult = styled.span<{ last?: boolean }>`
  margin-left: 0px;
`;

const TotalQuestions = styled.span`
  color: var(--neutral-color-100, #e5e6e7);
  font-family: Aprova Nova;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -1px;
  align-self: flex-end;
  margin-bottom: 19px;
`;

const Icon = styled.img`
  max-width: 20px;
  height: 20px;
  fill: #666666;
`;

const ResultQuestion = styled.div<{ correct?: boolean }>`
  color: ${(props) => (props.correct ? '#00c974' : '#DB3D4D')};
  font-family: 'Aprova Nova';
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -1px;
  text-align: left;
  display: flex;
  padding: 30px;
  border-bottom: solid 1px #f5f5f5;
`;
const Button = styled.button<{ showButton?: boolean }>`
  background: #00e88f;
  padding: 24px;
  width: 100%;
  font-family: 'Aprova Nova';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.6px;
  border-radius: 0px 0px 8px 8px;
  color: #111111;
  position: fixed;
  bottom: 0;
  @media (max-width: 480px) {
    border-radius: 0;
  }
`;

const ExamTitle = styled.span`
  color: var(--color-primary-gray-07, #fff);
  font-family: Aprova Nova;
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  line-height: 52px; /* 108.333% */
  letter-spacing: -1.8px;
`;

export const Result: React.FC<any> = ({ exercises }) => {
  const correct: boolean[] = [];
  const incorrect: boolean[] = [];

  exercises?.exercisesQuestion.map((question) => {
    if (question.correct) {
      correct.push(question);
    } else {
      incorrect.push(question);
    }
  });

  const finalGrade =
    correct.length > 0
      ? ((10 * correct.length) / exercises.exercisesQuestion.length).toFixed(1)
      : 0;

  return (
    <ResultContainer>
      <TitleContainer>
        <ExamTitle>Avaliação</ExamTitle>
        <ResultTitle>Seu Resultado</ResultTitle>
      </TitleContainer>
      <Container>
        <ContainerResult>
          <ResultText>
            <ResultTextIcon>
              <img src={Correct} alt="" />
              <p>Acertos</p>
            </ResultTextIcon>
            <ResultTextContainer>
              <TotalResult>{correct.length}</TotalResult>
              <TotalQuestions>{`/${exercises?.exercisesQuestion.length}`}</TotalQuestions>
            </ResultTextContainer>
          </ResultText>
          <ResultText>
            <ResultTextIcon>
              <img src={Wrong} alt="" />
              <p>Erros</p>
            </ResultTextIcon>
            <ResultTextContainer>
              <TotalResult last>{incorrect.length}</TotalResult>
              <TotalQuestions>{`/${exercises?.exercisesQuestion.length}`}</TotalQuestions>
            </ResultTextContainer>
          </ResultText>
          <ResultText>
            <p>Nota</p>
            <ResultText>{finalGrade}</ResultText>
          </ResultText>
        </ContainerResult>
      </Container>
      <Container>
        <TitleContainer>
          <ResultTitle>Gabarito comentado</ResultTitle>
        </TitleContainer>
      </Container>
      <ContainerQuestions>
        <MultiStep exercises={exercises} resultPage={true} />
      </ContainerQuestions>
    </ResultContainer>
  );
};

export default observer(Result);
